import { SelectText } from '../../ui/inputs/SelectText'
import { useProductionStore } from '../../../stores/production'
import { useEffect } from 'react';
import { getCustomerFiles } from '../../../api/customerFile';
import { showToastError } from '../../../services/toast';

const ClientFiles = () => {
  const { formData, setFormData, clientFiles, setClientFiles } = useProductionStore()

  const handleSelectTextChange = (selectedOption: any) => {
    if (selectedOption) {
      setFormData({ ...formData, idCustomerFile: selectedOption.value });
    } else {
      setFormData({ ...formData, idCustomerFile: null });
    }
  };

  useEffect(() => {
    getCustomerFiles()
    .then((res) => {
        const formattedData = res.data.map((item: any) => ({
            label: item.name,
            value: item.id,
        }));
        const sortedData = formattedData.sort((a: any, b: any) => a.label.localeCompare(b.label));
        setClientFiles(sortedData);
    })
    .catch((err) => {
      showToastError(err.response.data.message)
    });
  }, [])

  return (
    <SelectText
        label="Nom du client"
        name="idCustomerFile"
        value={formData.idCustomerFile}
        onChange={handleSelectTextChange}
        fetchOptions={clientFiles}
        className="w-60 cursor-pointer font-Nunito"
    />
  )
}

export default ClientFiles;
